// DEPRECATED
const genId = () => Date.now() + parseInt(Math.random().toString().substr(2, 9), 10);

export default genId;
